/**
 * @desc 发货明细
 */
const URL = "/rantion-oms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.oms.systemOrderPackage.getOrderPackageDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrderPackage/getOrderPackageDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
